import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import AddUserModal from "./Element/userModals/adduser";
import DeleteUser from "./Element/userModals/deleteuser";
import EditUser from "./Element/userModals/edituser"


function UserList() {
    const [adduserModal, setadduserModal] = useState(false);
    //  const [viewModal, setviewModal] = useState(false);
    const [updateUserModal, setupdateUserModal] = useState(false);
    const [deleteUserModal, setdeleteUserModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const token = localStorage.getItem('token');
            if (!token) {
                setError("No authentication token found");
                setLoading(false);
                return;
            }
            
            const res = await fetch('https://api.magsayo.net/api/users', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!res.ok) {
                setError(`Failed to fetch users: ${res.status}`);
                setLoading(false);
                return;
            }
            
            const data = await res.json();
            setUsers(data);
        } catch (error) {
            console.error("Error fetching users:", error);
            setError("Network error occurred");
        } finally {
            setLoading(false);
        }
    };

    const filteredUsers = users.filter((user) => {
        const term = searchTerm.toLowerCase();
        return [
            user.f_name,
            user.l_name,
            user.username,
            user.email,
            user.role,
            user.status,
            user.u_address
        ].some((value) => value?.toLowerCase().includes(term));
    });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.max(1, Math.ceil(filteredUsers.length / rowsPerPage));

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Users</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">User Management</li>
                        <li className="breadcrumb-item active">Users </li>
                    </ol>
                </nav>
            </div>

            {loading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : error ? (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            ) : (
            <section className="section dashboard">
                <div className="row">
                    <div className="col-12">
                        <div className="card recent-sales overflow-auto">



                            <div className="card-body">

                                {/* Search Area */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="card-title m-0">User List</h5>

                                    {/* Right side: Search + Add Button */}
                                    <div className="d-flex align-items-center gap-2">

                                        {/* Search */}
                                        <input
                                            type="text"
                                            className="form-control form-control-sm me-2"
                                            placeholder="Search user..."
                                            style={{ width: "220px" }}
                                            value={searchTerm}
                                            onChange={(e) => {
                                                setSearchTerm(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                        />

                                        {/* Add User Button */}
                                        <button type="button" className="btn btn-success btn-sm"
                                            onClick={() => setadduserModal(true)}>
                                            <i className="bi bi-plus-lg me-1"></i>
                                            Add User
                                        </button>
                                    </div>
                                </div>

                                {/* Table */}
                                <table className="table datatable">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Role</th>
                                            <th>Status</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentUsers.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="text-center py-4">
                                                    No users found.
                                                </td>
                                            </tr>
                                        ) : (
                                            currentUsers.map((user) => (
                                                <tr key={user.id}>
                                                    <th>{user.id}</th>
                                                    <td>{user.f_name} {user.l_name}</td>
                                                    <td className="text-primary">{user.email}</td>
                                                    <td>{user.role}</td>
                                                    <td>
                                                        <span className={`badge ${user.status === "Active"
                                                            ? "bg-success"
                                                            : user.status === "Blocked"
                                                                ? "bg-danger"
                                                                : "bg-warning"
                                                            }`}>
                                                            {user.status}
                                                        </span>
                                                    </td>

                                                    <td className="text-center">
                                                        <div className="dropdown">
                                                            <i
                                                                className="bi bi-three-dots-vertical"
                                                                role="button"
                                                                data-bs-toggle="dropdown"
                                                                style={{ fontSize: "18px", cursor: "pointer" }}
                                                            ></i>

                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li>
                                                                    <Link className="dropdown-item d-flex align-items-center" to={`/User_Profile/${user.id}`}>
                                                                        <i className="bi bi-person me-2"></i>
                                                                        View Profile
                                                                    </Link>
                                                                </li>

                                                                <li>
                                                                    <button className="dropdown-item d-flex align-items-center text-primary"
                                                                        onClick={() => setupdateUserModal(true)}>
                                                                        <i className="bi bi-pencil-square me-2"></i>
                                                                        Update
                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button className="dropdown-item d-flex align-items-center text-danger"
                                                                        onClick={() => setdeleteUserModal(true)}>
                                                                        <i className="bi bi-trash me-2"></i>
                                                                        Delete
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <nav className="mt-3">
                                    <ul className="pagination justify-content-end">

                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                        </li>
                                        {[...Array(totalPages)].map((_, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            )}
            <AddUserModal
                showAdduser={adduserModal}
                handleClose={() => setadduserModal(false)}
            />
            <DeleteUser
                showDeleteuser={deleteUserModal}
                handleClose={() => setdeleteUserModal(false)}
            />
            <EditUser
                showEdituser={updateUserModal}
                handleClose={() => setupdateUserModal(false)}
            />
        </main>
    );
}

export default UserList;

